// import { NavLink, useLocation } from "react-router-dom";
// import { useEffect, useMemo, useState } from "react";
// import { HiOutlineMenuAlt3 } from "react-icons/hi";
// import { IoClose } from "react-icons/io5";
// import { HiSparkles } from "react-icons/hi2";
// import { useAuth } from "../context/AuthContext";

// /* ================= Shared Link Styles ================= */

// const baseLinkClass =
//   "relative text-sm font-semibold px-3 py-2 rounded-lg " +
//   "transition-all duration-300 ease-out " +
//   "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/50";

// const getLinkClass = ({ isActive }) =>
//   `${baseLinkClass} ${isActive
//     ? "text-white bg-white/10"
//     : "text-gray-300 hover:text-white hover:bg-white/5"
//   }
//    md:after:absolute md:after:left-1/2 md:after:-translate-x-1/2 md:after:bottom-0
//    md:after:h-0.5 md:after:transition-all md:after:duration-300
//    md:after:bg-gradient-to-r md:after:from-blue-500 md:after:to-purple-500
//    ${isActive ? "md:after:w-3/4" : "md:after:w-0 hover:md:after:w-3/4"}`;

// export default function Navbar() {
//   const { user, isLoggedIn } = useAuth();
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   const navLinks = useMemo(
//     () => [
//       { label: "Home", to: "/" },
//       { label: "About", to: "/about" },
//       { label: "Courses", to: "/courses" },
//       { label: "Pricing", to: "/pricing" },
//       { label: "Testimonials", to: "/testimonials" },
//       { label: "Contact", to: "/contact" },
//     ],
//     []
//   );

//   /* ================= Effects ================= */

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Close drawer on route change
//   useEffect(() => setIsOpen(false), [location.pathname]);

//   // Lock body scroll when menu open
//   useEffect(() => {
//     document.body.style.overflow = isOpen ? "hidden" : "unset";
//     return () => (document.body.style.overflow = "unset");
//   }, [isOpen]);

//   return (
//     <header className="fixed top-0 left-0 w-full z-[100]">
//       <nav
//         className={`transition-all duration-300 ${scrolled || isOpen
//             ? "bg-gray-900 shadow-xl border-b border-white/10"
//             : "bg-gray-900/80 backdrop-blur-md border-b border-white/5"
//           }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-20">

//             {/* ============ Logo ============ */}
//             <NavLink
//               to="/"
//               className="group flex items-center gap-3 transition-transform hover:scale-105"
//             >
//               <div className="relative">
//                 <div className="absolute inset-0 bg-indigo-500 rounded-xl blur-md opacity-30 group-hover:opacity-60" />
//                 <div className="relative bg-white rounded-xl p-2 shadow-xl">
//                   <img
//                     src="/images/logo.png"
//                     alt="Well Spoken Logo"
//                     className="h-12 w-auto"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <span className="block text-xl font-bold text-white">
//                   Well Spoken
//                 </span>
//                 <span className="hidden sm:block text-[12px] text-white">
//                   Put your best word forward!
//                 </span>

//               </div>
//             </NavLink>

//             {/* ============ Desktop Menu ============ */}
//             <div className="hidden md:flex items-center gap-2">
//               {navLinks.map((link) => (
//                 <NavLink key={link.to} to={link.to} className={getLinkClass}>
//                   {link.label}
//                 </NavLink>
//               ))}

//               {isLoggedIn && (
//                 <NavLink
//                   to="/dashboard/profile"
//                   className="ml-4 flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold text-white
//                              bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500
//                              hover:shadow-indigo-500/40 transition-all"
//                 >
//                   <HiSparkles className="w-4 h-4" />
//                   Dashboard ({user?.user?.name || "User"})
//                 </NavLink>
//               )}
//             </div>

//             {/* ============ Mobile Toggle ============ */}
//             <button
//               onClick={() => setIsOpen(true)}
//               className="md:hidden p-2 rounded-xl bg-white/5 text-gray-300 hover:text-white"
//               aria-label="Open Menu"
//             >
//               <HiOutlineMenuAlt3 size={28} />
//             </button>
//           </div>
//         </div>

//         {/* ============ Mobile Menu (INSTANT OPEN) ============ */}
//         {isOpen && (
//           <div className="fixed inset-0 z-[120] md:hidden">

//             {/* Backdrop */}
//             <div
//               className="absolute inset-0 bg-black/80 backdrop-blur-sm"
//               onClick={() => setIsOpen(false)}
//             />

//             {/* Drawer */}
//             <aside
//               className="
//                 absolute right-0 top-0 h-full
//                 w-[280px] sm:w-[320px]
//                 bg-gray-900 border-l border-white/10
//                 flex flex-col
//                 animate-slideIn
//               "
//             >
//               {/* Close Button */}
//               <button
//                 onClick={() => setIsOpen(false)}
//                 className="absolute top-6 right-6 text-gray-400 hover:text-white"
//                 aria-label="Close Menu"
//               >
//                 <IoClose size={28} />
//               </button>

//               <div className="flex-1 px-6 pt-24 pb-8 space-y-2 overflow-y-auto">
//                 <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold mb-4">
//                   Navigation
//                 </p>

//                 {navLinks.map((link) => (
//                   <NavLink
//                     key={link.to}
//                     to={link.to}
//                     className={({ isActive }) =>
//                       `block w-full px-4 py-4 rounded-xl text-base font-semibold transition-colors ${isActive
//                         ? "bg-white/10 text-white"
//                         : "text-gray-400 hover:bg-white/5 hover:text-white"
//                       }`
//                     }
//                   >
//                     {link.label}
//                   </NavLink>
//                 ))}

//                 {isLoggedIn && (
//                   <NavLink
//                     to="/dashboard/profile"
//                     className="
//                       mt-6 flex items-center justify-center gap-2 p-4 rounded-xl
//                       font-bold text-white
//                       bg-gradient-to-r from-blue-600 to-purple-600
//                     "
//                   >
//                     <HiSparkles />
//                     Dashboard ({user?.user?.name || "User"})
//                   </NavLink>
//                 )}
//               </div>
//             </aside>
//           </div>
//         )}
//       </nav>

//       {/* Animation */}
//       <style>
//         {`
//           @keyframes slideIn {
//             from { transform: translateX(100%); }
//             to { transform: translateX(0); }
//           }
//           .animate-slideIn {
//             animation: slideIn 0.3s ease-out forwards;
//           }
//         `}
//       </style>
//     </header>
//   );
// }

import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { HiSparkles } from "react-icons/hi2";
import { useAuth } from "../context/AuthContext";

/* ================= Theme Constants ================= */
// Extracted exact "S" color from your logo
const BRAND_RED = "#911c14";
// "#d93a30" - first
// "#9e2a23" - second
/* ================= Shared Link Styles ================= */

const baseLinkClass =
  "relative text-sm font-bold px-4 py-2 rounded-lg transition-all duration-300 " +
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50";

const getLinkClass = ({ isActive }) =>
  `${baseLinkClass} ${isActive
    ? "text-white bg-white/30 shadow-inner"
    : "text-white/90 hover:text-white hover:bg-white/20"
  }`;

export default function Navbar() {
  const { user, isLoggedIn } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navLinks = useMemo(
    () => [
      { label: "Home", to: "/" },
      { label: "About", to: "/about" },
      { label: "Courses", to: "/courses" },
      { label: "Pricing", to: "/pricing" },
      { label: "Testimonials", to: "/testimonials" },
      { label: "Contact", to: "/contact" },
    ],
    []
  );

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => setIsOpen(false), [location.pathname]);

  return (
    <header className="fixed top-0 left-0 w-full z-[100]">
      <nav
        style={{ backgroundColor: BRAND_RED }}
        className={`transition-all duration-300 ${scrolled ? "shadow-2xl py-2" : "py-4"
          } border-b border-white/10`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">

            {/* ============ Logo ============ */}
            <NavLink
              to="/"
              className="flex items-center gap-3 transition-transform "
            >
              <div className="bg-white p-1.5 rounded-lg shadow-md">
                <img
                  src="/images/logo.png"
                  alt="Well Spoken Logo"
                  className="h-12 w-auto"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-black text-white leading-none tracking-tight">
                  WELL SPOKEN
                </span>
                <span className="hidden sm:block text-[10px] font-bold text-white uppercase tracking-widest">
                  Put your best word forward!
                </span>
              </div>
            </NavLink>

            {/* ============ Desktop Menu ============ */}
            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <NavLink key={link.to} to={link.to} className={getLinkClass}>
                  {link.label}
                </NavLink>
              ))}

              {isLoggedIn && (
                <NavLink
                  to="/dashboard/profile"
                  className="ml-4 flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-black 
                             bg-white text-[#d93a30] hover:bg-gray-100 transition-colors shadow-lg"
                >
                  <HiSparkles className="w-4 h-4" />
                  DASHBOARD ({user?.user?.name || "User"})
                </NavLink>
              )}
            </div>

            {/* ============ Mobile Toggle ============ */}
            <button
              onClick={() => setIsOpen(true)}
              className="md:hidden p-2 rounded-lg text-white hover:bg-black/10 transition-colors"
            >
              <HiOutlineMenuAlt3 size={28} />
            </button>
          </div>
        </div>

        {/* ============ Mobile Menu ============ */}
        {isOpen && (
          <div className="fixed inset-0 z-[120] md:hidden">
            <div className="absolute inset-0 bg-black/60" onClick={() => setIsOpen(false)} />
            <aside
              style={{ backgroundColor: BRAND_RED }}
              className="absolute right-0 top-0 h-full w-[280px] shadow-2xl flex flex-col animate-slideIn border-l border-white/10"
            >
              <div className="p-6 flex justify-end">
                <button onClick={() => setIsOpen(false)} className="text-white">
                  <IoClose size={32} />
                </button>
              </div>

              <div className="px-6 space-y-2">
                {navLinks.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    className={({ isActive }) =>
                      `block px-4 py-4 rounded-xl text-lg font-bold transition-all ${isActive ? "bg-white text-[#d93a30]" : "text-white "
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                ))}

                {isLoggedIn && (
                  <NavLink
                    to="/dashboard/profile"
                    className="mt-8 flex items-center justify-center gap-2 p-4 rounded-xl font-bold bg-white text-[#d93a30]"
                  >
                    <HiSparkles />
                    Dashboard ({user?.user?.name || "User"})
                  </NavLink>
                )}
              </div>
            </aside>
          </div>
        )}
      </nav>

      <style>{`
        @keyframes slideIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
        .animate-slideIn { animation: slideIn 0.3s ease-out forwards; }
      `}</style>
    </header>
  );
}